function generateRandomShipments() {
    const origins = ["Los Angeles, CA", "Miami, FL", "Dallas, TX", "New York, NY", "San Francisco, CA"];
    const destinations = ["Queretaro", "Monterrey", "Leon"];
    const modalities = ["AIR", "GROUND", "SEA"];
    const serviceTypes = ["FTL", "LTL"];
    const packageTypes = ["pallet", "boxes", "container"];
    const statuses = ["In Transit", "Created", "Delivered"];
    const detailedStatuses = [
        "Scheduled for pickup",
        "Picked Up",
        "In-Land Transport",
        "Waiting for CC",
        "International Transit",
        "Arrived to Destination",
        "Delivered to Consignee"
    ];

    const randomFromArray = (arr) => arr[Math.floor(Math.random() * arr.length)];

    const generateRandomDate = () => {
        let date = new Date();
        date.setDate(date.getDate() + Math.floor(Math.random() * 30));
        return `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
    };

    const shipments = [];

    for (let i = 0; i < 15; i++) {
        const status = randomFromArray(statuses);
        const detailedStatus = randomFromArray(detailedStatuses);
        let statusColor = "bg-green-200";

        if (status === "In Transit") {
            statusColor = Math.random() > 0.5 ? "bg-red-300" : "bg-yellow-300";
        } else if (status === "Created") {
            statusColor = "bg-gray-200";
        }

        shipments.push({
            shipmentNumber: `SN${i + 1000}`,
            status,
            detailedStatus, 
            statusColor,
            origin: randomFromArray(origins),
            destination: randomFromArray(destinations),
            shipper: `Shipper ${i}`,
            consignee: `Consignee ${i}`,
            modality: randomFromArray(modalities),
            serviceType: randomFromArray(serviceTypes),
            customerReference: `CR${i + 100}`,
            estimatedDeparture: generateRandomDate(),
            estimatedArrival: generateRandomDate(),
            newEstimatedArrival: generateRandomDate(),
            packageQuantity: Math.floor(Math.random() * 10) + 1,
            packageType: randomFromArray(packageTypes),
        });
    }

    return shipments;
}

export default generateRandomShipments;
